<template>
    <section class="friend_tab_content flex">

        <div class="title_notice_line">
            <div class="coeffs_heading container">
                <h1 class="page-title title is-size-2 has-text-weight-bold">{{ $t('modules.refs.formStep3.title') }}</h1>
                <notifText v-html="$t('modules.refs.formStep3.globalNotice')" />
            </div>
        </div>

        <div class="widget_helpers container">
            <div class="columns">
                <div class="column">
                    <div class="total_slider_container" :class="statusClass">
                        <CoeffSlider :disabled="true" coeff-id="total" :label="$t('modules.refs.formStep3.coeffTotal')" :ref-coeff="totalCoeffs" @change="syncVal" />
                    </div>
                </div>
                <div class="column">
                    
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="scores_columns_container">
                    <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title1') }}</h3>
                    <CoeffSlider coeff-id="r1" :ref-coeff="coeffs.r1"  @change="syncVal" />
                    <CoeffSlider coeff-id="r2" :ref-coeff="coeffs.r2"  @change="syncVal" />
                    <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title3') }}</h3>
                    <CoeffSlider coeff-id="r8" :ref-coeff="coeffs.r8"  @change="syncVal" />
                    <CoeffSlider coeff-id="r9" :ref-coeff="coeffs.r9"  @change="syncVal" />
                </div>
            </div>

            <div class="column">
                <div class="scores_columns_container">
                    <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title4') }}</h3>
                    <CoeffSlider coeff-id="r10" :ref-coeff="coeffs.r10"  @change="syncVal" />
                    <CoeffSlider coeff-id="r11" :ref-coeff="coeffs.r11"  @change="syncVal" />
                    <CoeffSlider coeff-id="r12" :ref-coeff="coeffs.r12"  @change="syncVal" />
                    <CoeffSlider coeff-id="r13" :ref-coeff="coeffs.r13"  @change="syncVal" />
                    <CoeffSlider coeff-id="r14" :ref-coeff="coeffs.r14"  @change="syncVal" />
                    <CoeffSlider coeff-id="r15" :ref-coeff="coeffs.r15"  @change="syncVal" />
                    <CoeffSlider coeff-id="r16" :ref-coeff="coeffs.r16"  @change="syncVal" />
                    <CoeffSlider coeff-id="r17" :ref-coeff="coeffs.r17"  @change="syncVal" />
                </div>
            </div>
            <div class="column">
                <div class="scores_columns_container">
                    <h3 class="dim_cat_title coeff_cat_title">{{ $t('dimensions.skills_titles.title2') }}</h3>
                    <CoeffSlider coeff-id="r3" :ref-coeff="coeffs.r3"  @change="syncVal" />
                    <CoeffSlider coeff-id="r4" :ref-coeff="coeffs.r4"  @change="syncVal" />
                    <CoeffSlider coeff-id="r5" :ref-coeff="coeffs.r5"  @change="syncVal" />
                    <CoeffSlider coeff-id="r6" :ref-coeff="coeffs.r6"  @change="syncVal" />
                    <CoeffSlider coeff-id="r7" :ref-coeff="coeffs.r7"  @change="syncVal" />
                </div>
            </div>
        </div>


    </section>
</template>

<script>

export default {
    name: 'FriendCoeffs',
    components: {

    },
    data(){
        return {}
    },
    computed: {
        friendRef(){
            return this.$store.state.FriendStore.friendRef
        },
        baseRef(){
            return this.friendRef.sight_ref
        },
        associatedRef(){
            return this.friendRef.sight_ref.associated_ref
        },
        coeffs(){
            return this.friendRef.coeffs
        },
        totalCoeffs(){
            return (
                this.coeffs.r1 + this.coeffs.r2 + this.coeffs.r5 + this.coeffs.r8 + this.coeffs.r6 + this.coeffs.r11
                + this.coeffs.r14 + this.coeffs.r13 + this.coeffs.r15 + this.coeffs.r16 + this.coeffs.r17
                + this.coeffs.r3 + this.coeffs.r7 + this.coeffs.r12 + this.coeffs.r4 + this.coeffs.r9 + this.coeffs.r10
            )
        },
        totalStatus(){
            if(this.totalCoeffs < 500){  return 'down'  }
            else if(this.totalCoeffs == 500){  return 'valid'  }
            else{  return 'up'  }
        },
        statusClass(){
            return this.totalStatus
        }
    },
    beforeCreate(){

    },
    methods: {
        syncVal(coeffData){
            const objectToSend = {coeffs: { } }
            objectToSend.coeffs[coeffData.id] = coeffData.val
            this.$store.commit('FriendStore/updateFriendRefData', objectToSend )
            const isValid = (this.totalStatus == 'valid')
            this.$emit('dataChange', isValid)
        },
        syncCoeffs(){
            // const objectToSend = { coeffs: this.associatedRef.coeffs }
            // this.$store.commit('RefStore/updateRefData', objectToSend )
        },
    }
}

</script>

<style lang="scss">
.friend_tab_content{
    .friends_heading{
        margin-bottom: 42px;
    }
}
</style>
